import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalida todo lo que muestra dinero del socio o del día: su cuenta
 * corriente, la caja, la morosidad y el Inicio (auditoría UX-10). Lo usan
 * registrar y anular un pago, para que ninguna pantalla quede mintiendo.
 */
export function refrescarTrasMovimientoDePago(qc: QueryClient, socioId: number): void {
  void qc.invalidateQueries({ queryKey: ["lecturas-pendientes", socioId] });
  void qc.invalidateQueries({ queryKey: ["pagos-socio", socioId] });
  void qc.invalidateQueries({ queryKey: ["resumen-cuenta", socioId] });
  void qc.invalidateQueries({ queryKey: ["caja"] });
  void qc.invalidateQueries({ queryKey: ["morosidad"] });
  void qc.invalidateQueries({ queryKey: ["dashboard"] });
}
